/**
 * @generated SignedSource<<c681170474df9bd561ea756b1c9899d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeScreenEventsCard_query$data = {
  readonly avatar1: string;
  readonly avatar2: string;
  readonly avatar3: string;
  readonly avatar4: string;
  readonly avatar5: string;
  readonly avatar6: string;
  readonly heroImageDesktop: string;
  readonly heroImageMobile: string;
  readonly person1: string;
  readonly person2: string;
  readonly person3: string;
  readonly person4: string;
  readonly person5: string;
  readonly person6: string;
  readonly " $fragmentType": "HomeScreenEventsCard_query";
};
export type HomeScreenEventsCard_query$key = {
  readonly " $data"?: HomeScreenEventsCard_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomeScreenEventsCard_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "path",
  "value": "home-page/event-hero.png"
},
v1 = {
  "kind": "Literal",
  "name": "transform",
  "value": {
    "dpr": 3,
    "fo": "face",
    "h": 80,
    "w": 80
  }
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeScreenEventsCard_query",
  "selections": [
    {
      "alias": "heroImageMobile",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "h": 190,
            "w": 200
          }
        }
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-hero.png\",transform:{\"dpr\":3,\"h\":190,\"w\":200})"
    },
    {
      "alias": "heroImageDesktop",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "w": 340
          }
        }
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-hero.png\",transform:{\"dpr\":3,\"w\":340})"
    },
    {
      "alias": "person1",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-person-1.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-person-1.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "person2",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-person-2.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-person-2.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "person3",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-person-3.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-person-3.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "person4",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-person-4.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-person-4.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "person5",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-person-5.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-person-5.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "person6",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-person-6.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-person-6.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "avatar1",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-avatar-1.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-avatar-1.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "avatar2",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-avatar-2.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-avatar-2.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "avatar3",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-avatar-3.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-avatar-3.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "avatar4",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-avatar-4.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-avatar-4.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "avatar5",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-avatar-5.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-avatar-5.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    },
    {
      "alias": "avatar6",
      "args": [
        {
          "kind": "Literal",
          "name": "path",
          "value": "home-page/event-avatar-6.png"
        },
        (v1/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "staticImageUrl",
      "storageKey": "staticImageUrl(path:\"home-page/event-avatar-6.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "ab2157ae62e38250871a27e1ed6945ad";

export default node;
